import {makeAutoObservable} from 'mobx'
import {isAuthenticated, authenticateSuccess, logout, getToken} from '../utils/Session'

function decodeJwtPayload(token) {
  const payload = token.split('.')[1]
  if (!payload) {
    throw new Error('Invalid token')
  }

  const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
  const paddedBase64 = base64 + '==='.slice((base64.length + 3) % 4)
  const decoded = atob(paddedBase64)
  const json = decodeURIComponent(decoded.split('').map(char => {
    const hex = char.charCodeAt(0).toString(16)
    return '%' + ('00' + hex).slice(-2)
  }).join(''))

  return JSON.parse(json)
}

class AppStore {
  constructor() {
    this.isLogin = !!isAuthenticated()
    this.loginUser = {}

    const token = getToken()
    if (token) {
      try {
        const decoded = decodeJwtPayload(token)
        this.loginUser = {
          email: decoded.email,
          name: decoded.name,
          picture: decoded.picture,
        }
      } catch (e) {
        // token invalid, ignore
      }
    }

    makeAutoObservable(this)
  }

  toggleLogin(flag, token, user) {
    if (flag && token) {
      authenticateSuccess(token)
      this.loginUser = user || {}
      this.isLogin = true
    } else {
      logout()
      this.loginUser = {}
      this.isLogin = false
    }
  }

  setLoginUser(user) {
    this.loginUser = user
  }
}

export default new AppStore()



// WEBPACK FOOTER //
// ./src/store/appStore.js